import React from 'react';
import './PlaylistCall.styl';
import {ReactComponent as Delete} from 'images/playlist/smallX.svg';
import throttle from 'lodash/throttle';

export default class PlaylistLiveCoachingStub extends React.PureComponent {
  render() {
    const {index, onDelete} = this.props;
    return (
      <div className="playlist-call livecoaching-stub">
        <div className="call-section">
          <div className="call-number blue-waves">
            <span>Call {index + 1}:</span>
          </div>
          <div className="call-info">
            <div className="flex-spacer">Live Coaching Call</div>
            <div
              className="icon-wrapper"
              onClick={throttle(e => {
                e.stopPropagation();
                onDelete();
              }, 1000)}>
              <Delete />
            </div>
          </div>
        </div>
        <div className="todo-section">
          <div className="live-coaching-text">
            I will coach a call live during the meeting.
            <br />
            (No action required from you right now)
          </div>
        </div>
      </div>
    );
  }
}
